import { render, staticRenderFns } from "./EModalExportarAulaPolivalencia.vue?vue&type=template&id=7939e6a4"
import script from "./EModalExportarAulaPolivalencia.vue?vue&type=script&lang=js"
export * from "./EModalExportarAulaPolivalencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports